import { types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils/utils';
import { Language } from './models/Language';

export const LanguageStore = types
  .compose(
    getBaseStore<typeof Language.Type, typeof Language.SnapshotType>(Language, 'languageId', 'language'),
    types.model('LanguageStore', {}),
  )
  .views((self) => ({
    getLanguageList() {
      return [
        { languageId: 1, alpha2: 'FR', englishName: 'FR' },
        { languageId: 2, alpha2: 'EN', englishName: 'EN' },
        { languageId: 3, alpha2: 'NL', englishName: 'NL' },
      ];
    },
    getByAlpha3(alpha3: string) {
      const res = [
        { languageId: 1, alpha3: 'FRA', englishName: 'FR' },
        { languageId: 2, alpha3: 'ENG', englishName: 'EN' },
        { languageId: 3, alpha3: 'NDL', englishName: 'NL' },
      ].find((language) => language.alpha3 === alpha3);
      return res;
    },
    getByAlpha2(alpha2: string) {
      const res = [
        { languageId: 1, alpha2: 'FR', englishName: 'FR' },
        { languageId: 2, alpha2: 'EN', englishName: 'EN' },
        { languageId: 3, alpha2: 'NL', englishName: 'NL' },
      ].find((language) => language.alpha2 === alpha2);
      return res;
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);

    return {};
  });

export type LanguageStoreType = typeof LanguageStore.Type;
